import axios from 'axios';
import * as React from 'react';
import { Fragment, useState } from 'react';
import {
  Button,
  Confirm, useNotify
} from 'react-admin';

const ResetViewsButton = (props) => {
    const [open, setOpen] = useState(false);
    //const refresh = useRefresh();
    const notify = useNotify();
    //const unselectAll = useUnselectAll();

    const {url,title,content,label,startIcon}=props;

    const handleClick = () =>setOpen(true);

    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        //updateMany();
        setOpen(false);
        //const url=url;
        const config = {
            method: 'PUT',
            url: url,
            headers: {
              "Authorization": "Bearer " + localStorage.getItem('token')
            }
          };
      
          axios(config).then((response) => {
            //  console.log(response);
            if (response.data.status === 'success'){
              window.location.reload();
            } 
            else notify(response.data.message);
          }).catch(function (error) {
            if (error.response) {
              // Request made and server responded
              notify(error.response.data.message,'warning');
              //console.log(error.response.data.message);
              //console.log(error.response.data.status);
              //console.log(error.response.status);
              //console.log(error.response.headers);
            } else if (error.request) {
              notify(error.request,'warning');
              // The request was made but no response was received
              //console.log(error.request);
            } else {
              notify(error.message,'warning');
              // Something happened in setting up the request that triggered an Error
              //console.log('Error', error.message);
            }
        
          });

          //unselectAll('/camp/updateLivraisonEtiq');


    };

    return (
        <Fragment>
            <Button label={label} startIcon={startIcon} onClick={handleClick} />
            <Confirm
                isOpen={open}
                loading={null}
                title={title}
                content={content}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default ResetViewsButton;

/*
    const [updateMany, { loading }] = useUpdateMany(
        url,
        selectedIds,
        { views: 0 },
        {
            onSuccess: () => {
                refresh();
                notify('Posts updated');
                unselectAll(url);
            },
            onFailure: error => notify('Error: posts not updated', 'warning'),
        }
    );


    */